import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isDefinedNotNull, isDefinedNotNullNotEmpty } from '@psnb/services';
import { QrScannerDialogData, QrScannerViewModel } from './qr-scanner-dialog.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'psnb-searchdata-qr-scanner-dialog',
  styleUrls: ['./qr-scanner-dialog.component.scss'],
  templateUrl: './qr-scanner-dialog.component.html'
})
export class SearchDataQrScannerDialogComponent implements OnInit {
  public vm: QrScannerViewModel;

  @ViewChild('focusFrame', { read: ElementRef }) private focusFrameElement?: ElementRef<HTMLElement>;
  @ViewChild('scanner', { read: ElementRef }) private scannerElement?: ElementRef<HTMLElement>;

  public constructor(
    private readonly cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: QrScannerDialogData,
    private dialogRef: MatDialogRef<SearchDataQrScannerDialogComponent>,
    private readonly renderer: Renderer2
  ) {}

  public ngOnInit(): void {
    this.vm = {
      title: this.data?.title ?? 'QR Code Scanner',
      zoomFlag: true,
      zoomLevel: 1
    };
  }

  /**
   * Handles successful QR code scan.
   * Closes the dialog and returns the scanned value.
   *
   * @param {string} scannedValue - The scanned QR code value
   */
  public scanSuccessHandler(scannedValue: string): void {
    if (isDefinedNotNullNotEmpty(scannedValue?.trim())) {
      this.dialogRef.close(scannedValue.trim());
    }
  }

  /**
   * Closes the dialog without returning a value.
   */
  public onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * Increases the zoom level for the scanner.
   */
  public zoomIn(): void {
    if (this.vm.zoomLevel < 1.4) {
      this.vm.zoomLevel = Math.round((this.vm.zoomLevel + 0.1) * 10) / 10;
      this.cdr.detectChanges();
      this.applyZoom();
    }
  }

  /**
   * Decreases the zoom level for the scanner.
   */
  public zoomOut(): void {
    if (this.vm.zoomLevel > 1) {
      this.vm.zoomLevel = Math.round((this.vm.zoomLevel - 0.1) * 10) / 10;
      this.cdr.detectChanges();
      this.applyZoom();
    }
  }

  /**
   * Applies the current zoom level to the scanner and focus frame.
   */
  private applyZoom(): void {
    if (isDefinedNotNull(this.scannerElement?.nativeElement)) {
      this.renderer.setStyle(this.scannerElement.nativeElement, 'transform', `scale(${this.vm.zoomLevel})`);
    }
    if (isDefinedNotNull(this.focusFrameElement?.nativeElement)) {
      this.renderer.setStyle(this.focusFrameElement.nativeElement, 'transform', `translate(-50%, -50%) scale(${this.vm.zoomLevel})`);
    }
  }
}
